<div class="flex flex-col mb-4">
    <div class="shadow-box flex flex-col items-center">
    
    @if(!pending && success == undefined && purchaseDescription){
        <h1>Zahlungsabwicklung</h1>

        <h2>Details</h2>
        <div class="w-full">
            <h3 class="mb-4">{{purchaseDescription.description}}</h3>

            @for(line of purchaseDescription.lines; track line){
            <div class="w-full flex justify-between">
                <span>{{line.description}}</span>
                <span>{{line.quantity}} x {{formatAmount(line.unitPrice.value)}} €</span>
            </div>
            <div class="w-full flex justify-between text-gray-600 text-sm mb-2">
                <span>(Einmalzahlung)</span>
                <span>MwSt. ({{formatPercent(line.vatRate)}}%): {{formatAmount(line.vatAmount.value)}} €</span>
            </div>
            }

            <div class="w-full pt-2 border-t flex justify-between">
                <span>Gesamtbetrag:</span>
                <span>{{formatAmount(purchaseDescription.amount.value)}} €</span>
            </div>
        </div>

        <h2 class="mt-8">Rechnungsadresse</h2>
        <form (ngSubmit)="onSubmit()" [formGroup]="billingAdressForm">
            <div class="flex flex-col md:flex-row md:gap-4 w-full">
                <div class="w-full md:w-1/6">
                    <label for="title" class="block text-sm font-medium leading-6">Anrede *</label>
                    <div class="mt-2">
                        <input id="title" formControlName="title" name="title"
                            class="block w-full rounded border border-grey py-1.5" type="text" required [ngClass]="{
                                    'invalid': billingAdressForm.get('title')?.invalid && (billingAdressForm.get('title')?.touched)
                                }">
                        @if (billingAdressForm.get('title')?.invalid && (billingAdressForm.get('title')?.touched)) {
                        <div class="text-red text-sm mt-2">
                            Bitte gebe eine Anrede ein (z.B. Herr, Frau, ...)
                        </div>
                        }
                    </div>
                </div>

                <div class="w-full md:w-5/12 mt-4 md:mt-0">
                    <label for="givenName" class="block text-sm font-medium leading-6">Vorname *</label>
                    <div class="mt-2">
                        <input id="givenName" formControlName="givenName" name="givenName"
                            class="block w-full rounded border border-grey py-1.5" type="text" required [ngClass]="{
                                    'invalid': billingAdressForm.get('givenName')?.invalid && (billingAdressForm.get('givenName')?.touched)
                                }">
                        @if (billingAdressForm.get('givenName')?.invalid &&
                        (billingAdressForm.get('givenName')?.touched)) {
                        <div class="text-red text-sm mt-2">
                            Vorname ist ungültig
                        </div>
                        }
                    </div>
                </div>

                <div class="w-full md:w-5/12 mt-4 md:mt-0">
                    <label for="familyName" class="block text-sm font-medium leading-6">Nachname *</label>
                    <div class="mt-2">
                        <input id="familyName" formControlName="familyName" name="familyName"
                            class="block w-full rounded border border-grey py-1.5" type="text" required [ngClass]="{
                                    'invalid': billingAdressForm.get('familyName')?.invalid && (billingAdressForm.get('familyName')?.touched)
                                }">
                        @if (billingAdressForm.get('familyName')?.invalid &&
                        (billingAdressForm.get('familyName')?.touched)) {
                        <div class="text-red text-sm mt-2">
                            Nachname ist ungültig
                        </div>
                        }
                    </div>
                </div>
            </div>

            <div class="mt-4">
                <label for="organizationName" class="block text-sm font-medium leading-6">Organisation</label>
                <div class="mt-2">
                    <input id="organizationName" formControlName="organizationName" name="organizationName"
                        class="block w-full rounded border border-grey py-1.5" type="text" [ngClass]="{
                                'invalid': billingAdressForm.get('organizationName')?.invalid && (billingAdressForm.get('organizationName')?.touched)
                            }">
                </div>
            </div>

            <div class="flex flex-col md:flex-row md:gap-4 mt-4">
                <div class="w-full md:w-2/3">
                    <label for="streetAndNumber" class="block text-sm font-medium leading-6">Straße & Hausnummer *</label>
                    <div class="mt-2">
                        <input id="streetAndNumber" formControlName="streetAndNumber" name="streetAndNumber"
                            class="block w-full rounded border border-grey py-1.5" type="text" required [ngClass]="{
                                    'invalid': billingAdressForm.get('streetAndNumber')?.invalid && (billingAdressForm.get('streetAndNumber')?.touched)
                                }">
                        @if (billingAdressForm.get('streetAndNumber')?.invalid &&
                        (billingAdressForm.get('streetAndNumber')?.touched)) {
                        <div class="text-red text-sm mt-2">
                            Bitte gebe eine gültige Straße und Hausnummer ein
                        </div>
                        }
                    </div>
                </div>

                <div class="w-full md:w-1/3 mt-4 md:mt-0">
                    <label for="streetAdditional" class="block text-sm font-medium leading-6">Zusätzliche
                        Adressdetails</label>
                    <div class="mt-2">
                        <input id="streetAdditional" formControlName="streetAdditional" name="streetAdditional"
                            class="block w-full rounded border border-grey py-1.5" type="text">
                    </div>
                </div>
            </div>

            <div class="flex flex-col md:flex-row md:gap-4 mt-4">
                <div class="w-full md:w-1/2">
                    <label for="postalCode" class="block text-sm font-medium leading-6">Postleitzahl *</label>
                    <div class="mt-2">
                        <input id="postalCode" formControlName="postalCode" name="postalCode"
                            class="block w-full rounded border border-grey py-1.5" type="text" [ngClass]="{
                                    'invalid': billingAdressForm.get('postalCode')?.invalid && (billingAdressForm.get('postalCode')?.touched)
                                }">
                        @if (billingAdressForm.get('postalCode')?.invalid &&
                        (billingAdressForm.get('postalCode')?.touched)) {
                        <div class="text-red text-sm mt-2">
                            Bitte gebe eine gültige PLZ ein
                        </div>
                        }
                    </div>
                </div>

                <div class="w-full md:w-1/2 mt-4 md:mt-0">
                    <label for="city" class="block text-sm font-medium leading-6">Stadt *</label>
                    <div class="mt-2">
                        <input id="city" formControlName="city" name="city"
                            class="block w-full rounded border border-grey py-1.5" type="text" required [ngClass]="{
                                    'invalid': billingAdressForm.get('city')?.invalid && (billingAdressForm.get('city')?.touched)
                                }">
                        @if (billingAdressForm.get('city')?.invalid && (billingAdressForm.get('city')?.touched)) {
                        <div class="text-red text-sm mt-2">
                            Bitte gebe eine gültige Stadt ein
                        </div>
                        }
                    </div>
                </div>
            </div>

            <div class="flex flex-col md:flex-row md:gap-4 mt-4">
                <div class="w-full md:w-1/2">
                    <label for="country" class="block text-sm font-medium leading-6">Land</label>
                    <div class="mt-2">
                        <input id="country" formControlName="country" name="country"
                            class="block w-full rounded border border-grey py-1.5 bg-gray-100" type="text" readonly>
                    </div>
                </div>

                <div class="w-full md:w-1/2 mt-4 md:mt-0">
                    <label for="region" class="block text-sm font-medium leading-6">Region</label>
                    <div class="mt-2">
                        <input id="region" formControlName="region" name="region"
                            class="block w-full rounded border border-grey py-1.5" type="text">
                    </div>
                </div>
            </div>

            <div class="mt-6 space-y-4">
                <!-- <div class="flex items-center">
                        <input id="saveDetails" type="checkbox" formControlName="saveDetails"
                            class="h-4 w-4 rounded border-grey text-primary focus:ring-primary">
                        <label for="saveDetails" class="ml-2 block text-sm">
                            Details für das nächste Mal speichern
                        </label>
                    </div> -->

                <div class="flex flex-col">
                    <p class="text-sm font-medium leading-6">Bezahlmethode</p>
                    <div class="mt-2 grid gap-2 md:grid-cols-2">
                        <label class="flex cursor-pointer items-center gap-2 rounded border border-grey px-3 py-2">
                            <input
                                type="radio"
                                name="paymentMethod"
                                [checked]="paymentMethod === 'paypal'"
                                (change)="setPaymentMethod('paypal')">
                            <span>PayPal</span>
                        </label>
                        <label class="flex cursor-pointer items-center gap-2 rounded border border-grey px-3 py-2">
                            <input
                                type="radio"
                                name="paymentMethod"
                                [checked]="paymentMethod === 'creditcard'"
                                (change)="setPaymentMethod('creditcard')">
                            <span>Kreditkarte</span>
                        </label>
                    </div>
                </div>

                <div class="flex flex-col">
                    <div class="flex items-center">
                        <input id="acceptTerms" type="checkbox" formControlName="acceptTerms" required
                            class="h-6 w-6 rounded-md border-grey text-primary focus:ring-primary" [ngClass]="{
                                    'invalid': billingAdressForm.get('acceptTerms')?.invalid && (billingAdressForm.get('acceptTerms')?.touched)
                                }">
                        <label for="acceptTerms" class="ml-2 block text-sm">
                            Ich habe die <a href="https://knoot-academy.de/agb" target="_blank">AGB</a> sowie die <a href="https://knoot-academy.de/datenschutz" target="_blank">Datenschutzbestimmungen</a> gelesen und
                            akzeptiere diese.
                        </label>
                    </div>
                    @if (billingAdressForm.get('acceptTerms')?.invalid &&
                    (billingAdressForm.get('acceptTerms')?.touched)) {
                    <div class="text-red text-sm mt-2">
                        Die AGBs und Datenschutzbestimmungen müssen akzeptiert werden, um mit dem Kauf fortzufahren
                    </div>
                    }
                </div>


                <div class="mt-8 flex justify-center">
                    <button type="submit"
                        class="px-6 py-2 rounded bg-primary text-white font-medium hover:bg-primary-dark transition-colors">
                        Zahlungspflichtig bestellen
                    </button>
                </div>

                <p class="text-sm">Mit * markierte Felder sind Pflichtfelder</p>
            </div>
        </form>

        }
        @else if(pending) {
        <div class="w-full flex flex-col items-center">
            <h2>Einen Moment bitte...</h2>
            <p>Deine Zahlung wird verarbeitet</p>
        </div>
        }
        @else if(success == true) {
        @if(purchaseType === 'bundle') {
        <div class="w-full max-w-[460px] flex flex-col gap-4 rounded-[14px] px-5 pt-5 pb-4 text-[#f8fbff] bg-gradient-to-b from-[#072b53] to-[#294765] shadow-[0_10px_24px_rgba(5,20,38,0.25)]">
            <div class="flex flex-col gap-2">
                <p class="m-0 text-[0.66rem] font-bold tracking-[0.09em] uppercase text-[#c8d6e8]">Kauf erfolgreich</p>
                <h2 class="m-0 leading-tight text-white">Danke fuer deinen Kauf!</h2>
                <p class="m-0 text-[#e0ebf8]">Dein Kurs wurde erfolgreich freigeschaltet.</p>
            </div>

            @if(bookDownloadUrl) {
            <div class="flex flex-col gap-3 rounded-2xl bg-white/5 p-3 ring-1 ring-white/10 sm:flex-row sm:items-end sm:justify-between">
                <div class="flex w-full flex-col gap-2 sm:max-w-[280px]">
                    <a class="inline-flex w-full items-center justify-center whitespace-nowrap rounded-full bg-white px-4 py-2 font-semibold text-[#0c2f58] shadow-sm transition-transform transition-colors hover:-translate-y-0.5 hover:bg-white/95" [routerLink]="['/training', courseId]">
                        Direkt mit dem Kurs starten
                    </a>
                    <button class="inline-flex w-full items-center justify-center whitespace-nowrap rounded-full border border-white/20 bg-white/10 px-4 py-2 font-semibold text-white shadow-sm transition-transform transition-colors hover:-translate-y-0.5 hover:bg-white/20" (click)="downloadBook()" type="button">
                        PDF herunterladen
                    </button>
                </div>
                <img class="h-auto w-16 shrink-0 self-center object-contain sm:w-20 sm:self-end" src="assets/img/knoot_winken_neu.png" alt="KnOot">
            </div>
            } @else {
            <div class="flex flex-col gap-3 rounded-2xl bg-white/5 p-3 ring-1 ring-white/10 sm:flex-row sm:items-center sm:justify-between">
                <a class="inline-flex w-full items-center justify-center rounded-full bg-white px-4 py-2 font-semibold text-[#0c2f58] shadow-sm transition-transform transition-colors hover:-translate-y-0.5 hover:bg-white/95 sm:flex-1" [routerLink]="['/training', courseId]">
                    Direkt mit dem Kurs starten
                </a>
                <img class="h-auto w-16 shrink-0 self-center object-contain sm:w-20" src="assets/img/knoot_winken_neu.png" alt="KnOot">
            </div>
            }
        </div>
        } @else {
        <div class="w-full max-w-[460px] flex flex-col gap-4 rounded-[14px] px-5 pt-5 pb-4 text-[#f8fbff] bg-gradient-to-b from-[#072b53] to-[#294765] shadow-[0_10px_24px_rgba(5,20,38,0.25)]">
            <div class="flex flex-col gap-2">
                <p class="m-0 text-[0.66rem] font-bold tracking-[0.09em] uppercase text-[#c8d6e8]">Kauf erfolgreich</p>
                <h2 class="m-0 leading-tight text-white">Danke fuer deinen Kauf!</h2>
                @if(purchaseType === 'book') {
                <p class="m-0 text-[#e0ebf8]">Dein Buchkauf wurde erfolgreich abgeschlossen.</p>
                } @else {
                <p class="m-0 text-[#e0ebf8]">Dein Kurs wurde erfolgreich freigeschaltet.</p>
                }
            </div>

            <div class="flex flex-col gap-3 rounded-2xl bg-white/5 p-3 ring-1 ring-white/10 sm:flex-row sm:items-center sm:justify-between">
                @if(purchaseType === 'book' && bookDownloadUrl) {
                <button class="inline-flex w-full items-center justify-center rounded-full bg-white px-4 py-2 font-semibold text-[#0c2f58] shadow-sm transition-transform transition-colors hover:-translate-y-0.5 hover:bg-white/95 sm:flex-1" (click)="downloadBook()" type="button">
                    PDF herunterladen
                </button>
                } @else {
                <a class="inline-flex w-full items-center justify-center rounded-full bg-white px-4 py-2 font-semibold text-[#0c2f58] shadow-sm transition-transform transition-colors hover:-translate-y-0.5 hover:bg-white/95 sm:flex-1" [routerLink]="['/training', courseId]">
                    Lege hier los mit deinem Kurs!
                </a>
                }
                <img class="h-auto w-16 shrink-0 self-center object-contain sm:w-20" src="assets/img/knoot_winken_neu.png" alt="KnOot">
            </div>
        </div>
        }
        } @else {
        <div class="w-full flex flex-col items-center">
            <h2>Es ist ein Fehler aufgetreten</h2>
            <p>{{ errorMessage || 'Bitte versuche es spaeter erneut.' }}</p>
            <button
                class="mt-4 underline"
                type="button"
                (click)="retryPurchase()">
                Erneut versuchen
            </button>
        </div>
        }
    </div>
</div>
